import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, Chip, Stack } from '@mui/material';
import { AcUnit, DirectionsCar, LocalShipping, LocalCarWash, CleaningServices, Grass, BugReport, Home, Plumbing, ElectricalServices, CheckCircle } from '@mui/icons-material';
import { servicesColors as colors } from '../theme';
const industries = [
    {
        title: 'HVAC',
        icon: _jsx(AcUnit, {}),
        roles: ['HVAC Tech', 'Install Tech', 'Service Tech'],
        certs: ['EPA 608', 'NATE'],
        color: colors.primaryLight,
    },
    {
        title: 'Auto Repair',
        icon: _jsx(DirectionsCar, {}),
        roles: ['Mechanic', 'Service Advisor', 'Detailer'],
        certs: ['ASE', 'State Insp.'],
        color: colors.accent,
    },
    {
        title: 'Moving',
        icon: _jsx(LocalShipping, {}),
        roles: ['Mover', 'Driver', 'Crew Lead'],
        certs: ['CDL', 'DOT'],
        color: colors.success,
    },
    {
        title: 'Car Wash',
        icon: _jsx(LocalCarWash, {}),
        roles: ['Detailer', 'Attendant', 'Manager'],
        certs: ['Driver Lic.'],
        color: colors.warning,
    },
    {
        title: 'Cleaning',
        icon: _jsx(CleaningServices, {}),
        roles: ['Cleaner', 'Team Lead', 'Supervisor'],
        certs: ['Background'],
        color: colors.primaryLight,
    },
    {
        title: 'Landscaping',
        icon: _jsx(Grass, {}),
        roles: ['Crew Member', 'Foreman', 'Designer'],
        certs: ['Pesticide Lic.'],
        color: colors.success,
    },
    {
        title: 'Pest Control',
        icon: _jsx(BugReport, {}),
        roles: ['Technician', 'Inspector', 'Sales'],
        certs: ['State Lic.'],
        color: colors.accent,
    },
    {
        title: 'Home Reno',
        icon: _jsx(Home, {}),
        roles: ['Carpenter', 'Installer', 'Helper'],
        certs: ['OSHA 10'],
        color: colors.primaryLight,
    },
    {
        title: 'Plumbing',
        icon: _jsx(Plumbing, {}),
        roles: ['Plumber', 'Apprentice', 'Service Tech'],
        certs: ['Journeyman', 'Master'],
        color: colors.accent,
    },
    {
        title: 'Electrical',
        icon: _jsx(ElectricalServices, {}),
        roles: ['Electrician', 'Apprentice', 'Estimator'],
        certs: ['Journeyman', 'Master'],
        color: colors.warning,
    },
];
export const IndustriesSection = () => {
    return (_jsx(Box, { component: "section", sx: { py: { xs: 8, md: 12 }, backgroundColor: '#ffffff' }, children: _jsxs(Container, { maxWidth: "lg", children: [_jsxs(Box, { sx: { textAlign: 'center', mb: 6 }, children: [_jsx(Typography, { sx: {
                                color: colors.accent,
                                fontWeight: 700,
                                fontSize: '0.9rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.15em',
                                mb: 1.5
                            }, children: "One Tool, Every Trade" }), _jsx(Typography, { variant: "h2", sx: {
                                fontWeight: 700,
                                color: colors.text,
                                fontSize: { xs: '1.75rem', md: '2.5rem' },
                                mb: 2
                            }, children: "Built for Local Service Businesses" }), _jsx(Typography, { sx: {
                                color: colors.textSecondary,
                                fontSize: '1.1rem',
                                maxWidth: 600,
                                mx: 'auto'
                            }, children: "Our AI understands trade certifications, licenses, and the specific skills that matter for each service industry." })] }), _jsx(Grid, { container: true, spacing: 2, children: industries.map((industry, index) => (_jsx(Grid, { size: { xs: 6, sm: 4, md: 2.4 }, children: _jsxs(Box, { sx: {
                                p: 2.5,
                                borderRadius: 3,
                                border: `1px solid ${colors.border}`,
                                height: '100%',
                                cursor: 'pointer',
                                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    borderColor: industry.color,
                                    transform: 'translateY(-6px) scale(1.02)',
                                    boxShadow: `0 16px 40px ${industry.color}25`,
                                    '& .industry-icon': {
                                        transform: 'scale(1.1) rotate(5deg)',
                                    },
                                },
                            }, children: [_jsx(Box, { className: "industry-icon", sx: {
                                        width: 48,
                                        height: 48,
                                        borderRadius: 2.5,
                                        backgroundColor: `${industry.color}12`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: industry.color,
                                        mb: 2,
                                        transition: 'transform 0.25s ease',
                                        '& svg': { fontSize: 24 },
                                    }, children: industry.icon }), _jsx(Typography, { sx: {
                                        fontWeight: 700,
                                        color: colors.text,
                                        fontSize: '0.95rem',
                                        mb: 1.5
                                    }, children: industry.title }), _jsx(Stack, { spacing: 0.5, sx: { mb: 1.5 }, children: industry.roles.slice(0, 2).map((role, i) => (_jsxs(Typography, { sx: {
                                            color: colors.textMuted,
                                            fontSize: '0.75rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.5,
                                        }, children: [_jsx(CheckCircle, { sx: { fontSize: '0.7rem', color: colors.success } }), role] }, i))) }), _jsx(Stack, { direction: "row", spacing: 0.5, flexWrap: "wrap", children: industry.certs.map((cert, i) => (_jsx(Chip, { label: cert, size: "small", sx: {
                                            height: 20,
                                            fontSize: '0.65rem',
                                            fontWeight: 600,
                                            backgroundColor: `${industry.color}15`,
                                            color: industry.color,
                                            '& .MuiChip-label': { px: 1 },
                                        } }, i))) })] }) }, index))) })] }) }));
};
